"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiChargeDto = exports.BillingApiChargeAbstractDto = void 0;
const billing_core_charge_repeat_enum_1 = require("../../../../billing-core/billing-core-charge/types/enums/billing-core-charge-repeat.enum");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const swagger_1 = require("../../../../swagger-fake");
const class_validator_1 = require("class-validator");
const billing_api_transfer_dto_1 = require("../../../billing-api-transfer/types/dtos/billing-api-transfer.dto");
const key_value_1 = require("../../../../shared/types/key-value");
const class_transformer_1 = require("class-transformer");
let BillingApiChargeAbstractDto = class BillingApiChargeAbstractDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма начисления",
  type: String,
  format: "decimal",
  pattern: "^d{1,}(.d{1,6})?$",
  example: "100.00"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsDecimal)({
  decimal_digits: "1,"
}), __metadata("design:type", String)], BillingApiChargeAbstractDto.prototype, "amount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Идентификатор сделки`,
  format: "uuid"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiChargeAbstractDto.prototype, "orderId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Id платёжного счёта для оплаты (необязательно). Если не указать, то
    можно оплатить со счёта по умолчанию для сделки, либо со счёта по умолчанию для всех платежей,
    либо добавить новый способ оплаты.`,
  format: "uuid",
  type: String,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", Object)], BillingApiChargeAbstractDto.prototype, "accountId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Произвольное текстовое описание (будет показано в истории платежей). Можно использовать
    i18n ключ совместимый с системой-клиентом биллинга.`,
  type: String,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsString)(), __metadata("design:type", Object)], BillingApiChargeAbstractDto.prototype, "description", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Произвольные мета-данные для внешнего сервиса-клиента биллинга.
    Используется для поиска, сопоставления с оплачиваемым товаром/услугой,
    обогащения данными при выводе пользователю и т.д.
    Свойство обязательно и должно содержать минимум одну пару key=value для избежания 
    "неопознанных" начислений.`,
  type: () => key_value_1.Metadata,
  example: {
    meetingId: ""
  }
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsObject)(), __metadata("design:type", key_value_1.Metadata)], BillingApiChargeAbstractDto.prototype, "meta", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Версия мета-данных`,
  pattern: "int"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsNumber)(), (0, class_validator_1.IsPositive)(), __metadata("design:type", Number)], BillingApiChargeAbstractDto.prototype, "metaVersion", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Дата и время когда необходимо оплатить начисление (для отложенных начислений).
    Если требуется произвести оплату сразу после создания, то makePaymentAt указывается как текущие дата и время.
    Если не указано, то начисление можно оплатить отдельным действием оплаты в произвольный момент. `,
  type: String,
  format: "date-time",
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDate)(), __metadata("design:type", Object)], BillingApiChargeAbstractDto.prototype, "makePaymentAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Дата и время истения ожидания оплаты.`,
  type: String,
  format: "date-time",
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDate)(), __metadata("design:type", Object)], BillingApiChargeAbstractDto.prototype, "expiredAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Режим автоповтора (клонирования) начисления. Удобно для подписок.`,
  enum: billing_core_charge_repeat_enum_1.BillingCoreChargeRepeatEnum,
  required: false,
  default: billing_core_charge_repeat_enum_1.BillingCoreChargeRepeatEnum.NEVER
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsEnum)(billing_core_charge_repeat_enum_1.BillingCoreChargeRepeatEnum), __metadata("design:type", String)], BillingApiChargeAbstractDto.prototype, "repeat", void 0);
BillingApiChargeAbstractDto = __decorate([(0, swagger_1.ApiExtraModels)(billing_api_transfer_dto_1.BillingApiTransferDto)], BillingApiChargeAbstractDto);
exports.BillingApiChargeAbstractDto = BillingApiChargeAbstractDto;
class BillingApiChargeDto extends BillingApiChargeAbstractDto {}
__decorate([(0, swagger_1.ApiProperty)({
  description: "Трансферы. Срабатывают при успешной оплате начисления (если есть).",
  type: () => billing_api_transfer_dto_1.BillingApiTransferDto,
  nullable: true,
  required: false,
  isArray: true
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Array)], BillingApiChargeDto.prototype, "transfers", void 0);
exports.BillingApiChargeDto = BillingApiChargeDto;
